import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Box } from '@mui/material';

const CancelPage = () => {
    const navigate = useNavigate();

    return (
        <Box p={4} textAlign="center">
            <Typography variant="h4" gutterBottom>
                Payment Cancelled
            </Typography>
            <Typography variant="body1" mb={2}>
                You cancelled the payment before it was completed. No worries—your booking wasn't finalized.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/')}>
                Return to Home
            </Button>
        </Box>
    );
};

export default CancelPage;